// extracted by mini-css-extract-plugin
export default {"messagebody":"MessageBody_messagebody__2XAJP","image":"MessageBody_image__+4rXz","text":"MessageBody_text__CyOdu"};